// import React from 'react'
import _ from 'lodash'

export const RoleCode = {
	SUPERADMIN: 'Super Admin',
	SYSTEMADMIN: 'System Admin',
	CLERK: 'Clerk',
	CONTITUENT: 'Contituent',
	MEDICALPERSONNEL: 'Medical Personnel'
}

export const getRandomColors = () => {
	const randomColors = ['#4582ff', '#04d2c8', '#454080', '#ff9900', '#E82D53', '#ACAC2D']
	const _colorIndex = _.random(5)
	return randomColors[_colorIndex]
}

export const PaperSizes = [{
	index: 1,
	name: 'A4 (8.3 x 11.7 inches',
	format: 'A4',
	width: 8.3,
	height: 11.7
}, {
	index: 2,
	name: 'Letter (8.5 x 11 inches',
	format: 'letter',
	width: 8.5,
	height: 11
}, {
	index: 2,
	name: 'Long (8.5 x 13 inches',
	format: 'letter',
	width: 8.5,
	height: 13
}, {
	index: 2,
	name: 'Legal (8.5 x 14 inches',
	format: 'legal',
	width: 8.5,
	height: 14
}]